export function Header() {
  return (
    <header className="bg-blue-600 text-white py-4 shadow-md">
      <div className="container mx-auto px-4">
        <h1 className="text-2xl font-bold">Shadowverse Battle Log</h1>
      </div>
    </header>
  );
}
